import algoliasearch from 'algoliasearch/lite';

const getAlgoliaIndexPrefix = () => process.env.ALGOLIA_ENV_PREFIX;

const getAlgoliaAppId = () => process.env.ALGOLIA_APP_ID;

// locally use stage_
const getAlgoliaIndexNameGlobal = searchType => `${getAlgoliaIndexPrefix()}_${searchType}`;
const getAlgoliaIndexNameColleges = () => `${getAlgoliaIndexPrefix()}_colleges`;
const getAlgoliaIndexNameCompanies = () => `${getAlgoliaIndexPrefix()}_companies`;
const getAlgoliaIndexNameEvents = () => `${getAlgoliaIndexPrefix()}_events`;
const getAlgoliaIndexNameEverything = () => `${getAlgoliaIndexPrefix()}_everything`;
const getAlgoliaIndexNameEverythingSessions = () =>
    `${getAlgoliaIndexPrefix()}_everything_session_start_time_asc_virtual`;
const getAlgoliaIndexNameProperties = () => `${getAlgoliaIndexPrefix()}_properties`;
const getAlgoliaIndexNameMembers = () => `${getAlgoliaIndexPrefix()}_members`;
const algoliaClient = searchAPIKey => algoliasearch(getAlgoliaAppId(), searchAPIKey);
const initSearchClient = (client, trackEmptySearch = false) => ({
    ...client,
    search(requests) {
        const newRequests = requests.map(request => {
            // test for empty string and change request parameter: analytics
            if (!trackEmptySearch && (!request.params.query || request.params.query.length === 0)) {
                request.params.analytics = false;
            }

            return request;
        });

        return client.search(newRequests);
    },
});

export {
    getAlgoliaAppId,
    getAlgoliaIndexNameGlobal,
    getAlgoliaIndexNameColleges,
    getAlgoliaIndexNameCompanies,
    getAlgoliaIndexNameEvents,
    getAlgoliaIndexNameEverything,
    getAlgoliaIndexNameEverythingSessions,
    getAlgoliaIndexNameProperties,
    getAlgoliaIndexNameMembers,
    algoliaClient,
    initSearchClient,
};
